import { UsageEvent, UsageEventRow, UsageSummary } from "./types";

export const transformUsageEventRow = (res: any): UsageEventRow => ({
  id: res.id,
  occurredOn: res.occurredOn,
  pricingKeyCode: res.pricingKeyCode,
  subject: res.subject ?? "",
  vehicle: res.vehicle ?? null,
  userCreatedId: res.userCreatedId ?? null,
  userCreatedFullName: res.userCreatedFullName ?? null,
  quantity: res.quantity ?? 0,
  unitPrice: res.unitPrice ?? 0,
  amount: res.amount ?? 0,
  isSuccess: res.isSuccess ?? false,
  errorMessage: res.errorMessage ?? null,
});

/** Unos i odgovor stižu kao JSON tekst, pa se raspakiravaju ovdje, a ne u komponenti. */
const parseJson = (value: unknown): Record<string, any> | null => {
  if (!value || typeof value !== "string") return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const transformUsageEvent = (res: any): UsageEvent => ({
  ...transformUsageEventRow(res),
  pricingSchemeId: res.pricingSchemeId ?? null,
  sourceType: res.sourceType ?? null,
  sourceId: res.sourceId ?? null,
  request: parseJson(res.request),
  response: parseJson(res.response),
});

export const transformUsageSummary = (res: any): UsageSummary => ({
  count: res.count ?? 0,
  total: res.total ?? 0,
});
